import { Component, OnInit, OnDestroy } from "@angular/core";

@Component({
    selector: "data-loader",
    template: `
<div class="module-loading" style="left: 50% !important">
    <div class="module-loading__module">
        <div class="module-loading__placeholder-title"></div>
        <div class="module-loading__placeholder-content"></div>
    </div>
    <div class="module-loading__module">
        <div class="module-loading__placeholder-title"></div>
        <div class="module-loading__placeholder-content"></div>
    </div>
    <div class="module-loading__module">
        <div class="module-loading__placeholder-title"></div>
        <div class="module-loading__placeholder-content"></div>
    </div>
    <div class="app-load mt-5">
        <p>Wait while we load up your data..</p>
        <div class="progress">
            <div class="progress-bar" role="progressbar" style="max-width: 100%" aria-valuenow="96" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
    </div>
</div>
    `
})
export class DataLoaderComponent implements OnInit, OnDestroy {
    ngOnInit() {
        $(".footer").hide();
        $(".page-title").hide();
    }

    ngOnDestroy() {
        $(".footer").show();
        $(".page-title").show();
    }
}